import { ThemeBorderRadiiKeys } from './borderRadii';
import { ThemeColorsKeys } from './colors';
import { ThemeTypographyKeys } from './typography';

interface ThemeButtonBase {
  color: ThemeColorsKeys;
  background: ThemeColorsKeys;
  borderColor: ThemeColorsKeys;
  borderRadius: ThemeBorderRadiiKeys;
  underline?: boolean;
  collapse?: boolean;
  upperCase?: boolean;
}

interface ThemeButton extends ThemeButtonBase {
  type: ThemeTypographyKeys;
  hover: ThemeButtonBase;
}

const primaryBase = {
  background: 'brandTwo100',
  color: 'utilityWhite',
  hover: {
    underline: true,
  },
};

const buttons = {
  primary: {
    borderColor: 'brandTwo100',
    ...primaryBase,
  },
  primaryOnDark: {
    borderColor: 'brandOne50',
    ...primaryBase,
  },
  primaryOutline: {
    borderColor: 'brandTwo100',
    background: 'utilityWhite',
    color: 'brandTwo100',
    hover: {
      underline: true,
    },
  },
  secondary: {
    borderColor: 'brandTwo100',
    ...primaryBase,
  },
  secondaryOutline: {
    borderColor: 'brandTwo100',
    background: 'transparent',
    color: 'brandTwo100',
    hover: {
      underline: true,
    },
  },
  secondaryInverse: {
    borderColor: 'utilityWhite',
    background: 'utilityWhite',
    color: 'brandTwo100',
    hover: {
      underline: true,
    },
  },
  secondaryInverseOutline: {
    borderColor: 'utilityWhite',
    background: 'transparent',
    color: 'utilityWhite',
    hover: {
      underline: true,
    },
  },
} as const;

export default buttons;

export type ThemeButtonKeys = keyof typeof buttons;
export type ThemeButtons = Record<ThemeButtonKeys, ThemeButton>;
